import React from "react";
import { Urls } from "../../constants/UrlConstants";
import { RebrandHelper } from "../../helpers/brand/RebrandHelper";

const coronavirusLink = (
  <a
    href={Urls.AXACovidInfo}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Coronovirus support"
  >
    coronavirus support
  </a>
);

const brexitLink = (
  <a
    href={Urls.AXABrexitInfo}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Brexit travel"
  >
    Brexit travel
  </a>
);

export const SpecialInformationBannerContent = {
  headline: {
    MOL: null,
    HOL: "We're here for you",
    Saga: "Information about the coronavirus",
    International: "Information about the coronavirus"
  },
  message: {
    MOL: {
      Any: (<p><strong>We're here for you</strong> - visit our {coronavirusLink} and {brexitLink} pages on the main website.</p>),
      Saga: "Visit our main website for the latest information on the coronavirus."
    },
    HOL: (<p>Visit our {coronavirusLink} and {brexitLink} pages on the main {RebrandHelper.getAxaBrandName()} website.</p>)
  },
  buttonLabel: {
    MOL: null,
    HOL: null,
    Saga: "Read more",
    International: "Read more",
  },
  buttonLink: {
    MOL: null,
    HOL: null,
    Saga: Urls.AXACovidInfo,
    International: Urls.AXAGlobalCovidInfo
  },
  buttonAriaLabel: "Read more about Coronavirus"
};
